import { Controller } from "stimulus"
import Rails from 'rails-ujs'

export default class extends Controller {
  // Note, the element must be inside the form
  submit() {
    Rails.fire(this.element.form, 'submit')
  }
}
